"use client";

import React from "react";
import { MapPin, Phone, Mail, Clock, ArrowUpRight } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
const contactCards = [{
  id: "phone",
  iconName: "phone",
  title: "+39 02 496 75 955",
  value: "",
  description: "+39 02 496 75 955\n"
}, {
  id: "email",
  iconName: "mail",
  title: "info@studiodclegal.it",
  value: "",
  description: "info@studiodclegal.it"
}];
const openingHours = [{
  day: "Lunedì - Venerdì",
  hours: "09:00 - 13:00, 14:00 - 18:00"
}, {
  day: "Sabato - Domenica",
  hours: "Chiuso"
}];
export default function ContactInformation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="contactinformation" className="relative bg-background py-24 overflow-hidden z-0 !bg-[url(https://studiodclegal.it/wp-content/uploads/2026/03/Piazza-Affari-al-crepuscolo-a-Milano_2.png)]">
      <style dangerouslySetInnerHTML={{
      __html: `
        .article-title,
        .article-preview-title {
          font-family: var(--font-sans);
        }
      `
    }} />
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none -z-10">
        <div className="absolute top-[-20%] right-[-10%] w-[50%] h-[50%] rounded-full bg-[var(--ring)]/5 blur-[120px]" />
        <div className="absolute bottom-[-20%] left-[-10%] w-[50%] h-[50%] rounded-full bg-[var(--primary)]/5 blur-[120px]" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`grid lg:grid-cols-[1fr_1.2fr] gap-12 lg:gap-24 items-start transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="flex flex-col">
            <h2 className="font-sans text-foreground mb-6 !font-light !text-6xl">Contattaci</h2>
            <Separator className="w-24 h-[2px] bg-[var(--ring)] mb-8" />
            
          </div>

          {}
          <div className="flex flex-col">
            <Card className="border-white/10 backdrop-blur-md bg-card/20 shadow-2xl overflow-hidden">
              <CardHeader className="pb-2">
                <CardTitle className="text-2xl font-sans text-foreground">Dettagli di Contatto</CardTitle>
              </CardHeader>
              <CardContent className="space-y-8">
                <div className="grid gap-6">
                  <div className="flex items-start gap-4">
                    <div className="p-2 rounded-lg bg-[var(--ring)]/10">
                      <Phone className="w-5 h-5 text-[var(--ring)]" />
                    </div>
                    <div>
                      <p className="text-[10px] font-mono text-[var(--ring)] uppercase tracking-[0.2em] mb-1">Telefono</p>
                      <p className="text-foreground font-medium !text-base">+39 02 496 75 955</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="p-2 rounded-lg bg-[var(--ring)]/10">
                      <Mail className="w-5 h-5 text-[var(--ring)]" />
                    </div>
                    <div>
                      <p className="text-[10px] font-mono text-[var(--ring)] uppercase tracking-[0.2em] mb-1">Email</p>
                      <p className="text-foreground font-medium !text-base">info@studiodclegal.it</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="p-2 rounded-lg bg-[var(--ring)]/10">
                      <MapPin className="w-5 h-5 text-[var(--ring)]" />
                    </div>
                    <div>
                      <p className="text-[10px] font-mono text-[var(--ring)] uppercase tracking-[0.2em] mb-1">Indirizzo</p>
                      <p className="text-foreground font-medium">Via San Vittore al Teatro 3 20123 Milano (MI)</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="p-2 rounded-lg bg-[var(--ring)]/10">
                      <Clock className="w-5 h-5 text-[var(--ring)]" />
                    </div>
                    <div className="flex-1">
                      <p className="text-[10px] font-mono text-[var(--ring)] uppercase tracking-[0.2em] mb-1">Orari di Apertura</p>
                      <div className="space-y-2">
                        {openingHours.map((item, i) => <div key={i} data-index={i} className="flex justify-between text-sm border-b border-white/5 pb-1 last:border-0">
                            <span className="text-foreground/70 !text-base">{item.day}</span>
                            <span className="text-foreground font-medium">{item.hours}</span>
                          </div>)}
                      </div>
                    </div>
                  </div>
                </div>

              <a href="https://share.google/2P5AbwseUTiYjxJEn" target="_blank" rel="noopener noreferrer" className="w-full">
  <Button className="w-full bg-[var(--ring)] text-primary hover:bg-[var(--ring)]/90 h-12 text-base font-semibold group transition-all duration-300">
    Indicazioni
    <ArrowUpRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
  </Button>
</a>

              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}